<template>
  <div class="container">
    <div
      :style="{backgroundImage:`url('${imageAndre}')`}"
      class="bg-secondary my-5  text-white bg-cover about-container container-h bg-about1"
    >
      <div class="about-content p-4  h-100">
        <h3 class="mobile-title-text content-title">
          <b class="text-warning">工坊主人 拳王安德烈</b>
        </h3>
        <p class="h5 content-font my-3">
          來自於亞斯特拉，擁有高超精湛的打鐵技術的大師級工匠。安德烈同時具備精密機械相關知識，能夠製作出特殊機關兵器。
          年輕時曾到過名為"雅南"的古都，那是座被詛咒的城市，充滿著噬血的怪獸及狩獵這些怪獸的"獵人"，
          獵人們使用的武器都擁有獨特的機關。安德烈在這座都市認識了一位名為"格曼"的獵人，並從他那裡學會了機關兵器的製作方法。
        </p>
        <p class="h5 content-font my-3">
          雖然職業是鐵匠卻擁有能在各種險惡環境生存的能力，在成立工坊之前以流浪鐵匠的身分，
          遊走於各種危險區域為冒險者們提供服務，曾經有冒險者試圖打劫他，反而遭到鐵拳的制裁，因此被稱為 <b class="text-danger">拳王</b>。
        </p>
      </div>
    </div>
    <div
      :style="{backgroundImage:`url('${imageOrigin}')`}"
      class="bg-secondary my-5  text-white bg-cover about-container container-h bg-about2"
    >
      <div class="about-content p-4  h-100 ">
        <h3 class="mobile-title-text content-title">
          <b class="text-warning">工坊起源 追求極致</b>
        </h3>
        <p class="h5 content-font my-3">
          安德烈經歷了許多也因此聲名大噪，但他不因此而滿足，他不是個單純的鐵匠 <del class="text-danger">還是個拳王</del> ，
          他有能力但卻還沒做出能令自己真正滿意的作品。他發覺不能只是做出自己能夠做的，必須再次提高自己的境界。
          他希望那些將自己的命運置身於戰場的勇士們，能完全信任自己的裝備，將所有注意力放在眼前的敵人。
          他開始吸收不同的知識，並結識許多和他一樣專精於自己領域的人才。經過一些討論和思考，他們決定攜手合作。
          所以他與志同道合的夥伴們建立了工坊，各個領域的達人們各司其職、相輔相成，只為了達到 <b class="text-danger">天衣無縫</b>!
        </p>
      </div>
    </div>
    <div
      :style="{backgroundImage:`url('${imageLegend}')`}"
      class="bg-secondary my-5  text-white bg-cover about-container container-h bg-about3"
    >
      <div class="about-content p-4 h-100 ">
        <h3 class="mobile-title-text content-title" >
          <b class="text-warning">工坊目標 成就傳說</b>
        </h3>
        <p class="h5 content-font my-3">
          工坊出品的裝備是從高水準的技術誕生而成的藝術精品，更加堅固的鎧甲、更加堅固的兵器成為了難以撼動的口碑。
          但裝備真正的價值只有他的主人能為他定義。
        </p>
        <p class="h5 content-font my-3">
          我們不僅要得到你的信任，也期望你成就自己的故事。不要高估眼前的考驗，也不要低估現在的自己。
          我們會成為你強大的後盾，所以放手一搏吧 !<del class="text-danger"> 打倒拳王 </del> 成為被憧憬的對象，
          如同「漫步深淵」的孤高騎士 "亞爾特留斯"、「獵龍」的霸氣金獅 "翁斯坦"、「聖劍」持有者高尚的獵人 "路德維希"。
          為歷史譜出新的 <b class="text-danger">傳奇故事</b> 。
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      imageAndre: 'https://i.postimg.cc/kDr0xc7K/andre-banner-sm.jpg',
      imageOrigin: 'https://i.postimg.cc/K8VMHwVF/about2-sm.jpg',
      imageLegend: 'https://i.postimg.cc/GhLgLTpt/about-legend-sm-done.jpg',
      alreadyShow: false,
    };
  },
};
</script>
